namespace GeniuzPOS.CustomReport {
    export interface ReportCusSaleComparisonRow {
        Id?: string;
        ShopName?: string;
        Category1?: string;
        Category2?: string;
        Category3?: string;
        PluCode?: string;
        PluDesc?: string;
        BrandName?: string;
        SupplierId?: string;
        SupPlierName?: string;
        TwQtySold?: number;
        TwNetSalesExVat?: number;
        TwNetGpAmount?: number;
        TwNetGr?: number;
        LwQtySold?: number;
        LwNetSalesExVat?: number;
        LwNetGpAmount?: number;
        LwNetGr?: number;
        VarianceQtySold?: number;
        VarianceNetSalesExVat?: number;
        VarianceNetGpAmount?: number;
        VarianceNetGr?: number;
        PcVarianceQtySold?: number;
        PcVarianceNetSalesExVat?: number;
        PcVarianceNetGpAmount?: number;
    }

    export namespace ReportCusSaleComparisonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopName';
        export const localTextPrefix = 'CustomReport.ReportCusSaleComparison';
        export const deletePermission = '6CustomReport:SaleComparison:View';
        export const insertPermission = '6CustomReport:SaleComparison:View';
        export const readPermission = '6CustomReport:SaleComparison:View';
        export const updatePermission = '6CustomReport:SaleComparison:View';

        export declare const enum Fields {
            Id = "Id",
            ShopName = "ShopName",
            Category1 = "Category1",
            Category2 = "Category2",
            Category3 = "Category3",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            BrandName = "BrandName",
            SupplierId = "SupplierId",
            SupPlierName = "SupPlierName",
            TwQtySold = "TwQtySold",
            TwNetSalesExVat = "TwNetSalesExVat",
            TwNetGpAmount = "TwNetGpAmount",
            TwNetGr = "TwNetGr",
            LwQtySold = "LwQtySold",
            LwNetSalesExVat = "LwNetSalesExVat",
            LwNetGpAmount = "LwNetGpAmount",
            LwNetGr = "LwNetGr",
            VarianceQtySold = "VarianceQtySold",
            VarianceNetSalesExVat = "VarianceNetSalesExVat",
            VarianceNetGpAmount = "VarianceNetGpAmount",
            VarianceNetGr = "VarianceNetGr",
            PcVarianceQtySold = "PcVarianceQtySold",
            PcVarianceNetSalesExVat = "PcVarianceNetSalesExVat",
            PcVarianceNetGpAmount = "PcVarianceNetGpAmount"
        }
    }
}
